import script from "./ClientAddUnionDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddUnionDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientAddUnionDropdown.vue?vue&type=style&index=0&id=cdb6ee0e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb6ee0e"]])

export default __exports__